// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable design-system/ensure-design-token-usage */
.hGZntd8ttd8hDD {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #000000;
  color: #ffffff;
  text-align: center;
}
.jzWA_1MYm0ZUbg {
  position: relative;
  flex-grow: 1;
}
.uLySDfEkfTFbHS {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `hGZntd8ttd8hDD`,
	"videoWrapper": `jzWA_1MYm0ZUbg`,
	"videoIframe": `uLySDfEkfTFbHS`
};
export default ___CSS_LOADER_EXPORT___;
